import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ReactSVG } from "react-svg";
import Button from "../../../../common/Button";
import CustomInput from "../../../../common/CustomInput";
import { formatToYYYY_MMM_DD } from "../../../../../helpers/functions";
import { ClinicalServiceTypes } from "../../../text/data";

const ThirdCardFollowUp = ({
  selectedCard,
  setSelectedCard,
  clinicalServiceName,
  MRDate,
  setMRDate,
  halfBorderSection,
  cardIndex = 3
}) => {
  const navigate = useNavigate();
  const { id: patientId } = useParams();
  const isAllergicRhinitis = clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis;
  const isMedicationReview = clinicalServiceName === ClinicalServiceTypes.MedicationReview;

  const getCardTitle = () => {
    if (isAllergicRhinitis) {
      return "Medication Review (Optional)";
    } else if (isMedicationReview) {
      return "Minor Ailments Prescribing Service";
    }
    return "Service";
  };

  const getCardSubtitle = () => {
    if (isAllergicRhinitis) {
      return "Do you qualify for a Medication Review?";
    } else if (isMedicationReview) {
      return "Do you need help with a Minor Ailment?";
    }
    return "Service subtitle";
  };

  const getButtonText = () => {
    if (isAllergicRhinitis) {
      return "Eligibility Workflow Coming Soon";
    } else if (isMedicationReview) {
      return "Eligibility Workflow Coming Soon";
    }
    return "Coming Soon!";
  };

  const handleButtonClick = () => {
    // Navigate to Clinical Services page where user can select services
    navigate(`/patient/${patientId}/clinical-services/`);
  };

  const getBookedTitle = () => {
    if (isAllergicRhinitis) {
      return "Medication Review Booked";
    } else if (isMedicationReview) {
      return "Medication Review Booked";
    }
    return "Service Booked";
  };

  const getBookedText = () => {
    if (isAllergicRhinitis) {
      return "Medication Review booked:";
    } else if (isMedicationReview) {
      return "Medication Review booked:";
    }
    return "Service booked:";
  };

  return (
    <div
      className={`relative flex flex-row h-[516px] w-[525px] pl-[12px] pt-[14px] rounded-[12px] gap-[10px] border-t-[6px] border-l-[6px] pr-[16px] ${
        selectedCard === cardIndex
          ? "border-REELTeal"
          : "border-blue-200"
      }`}
    >
      {halfBorderSection(cardIndex)}
      <div
        className="flex flex-col justify-center h-[480px] w-[480px] rounded-[12px] bg-teal-25 border-b-gray-100 border-x-gray-100 border-[1px] shadow-lg shadow-gray-400 z-[0]"
        onClick={() => {
          setSelectedCard(cardIndex);
        }}
      >
        {MRDate === null && (
          <div className="flex flex-col h-[320px] pt-5 pb-2 gap-5 px-12 justify-center">
            <div className="flex flex-col gap-2">
              <h2 className="text-xl font-bold flex justify-center text-teal-300">
                {getCardTitle()}
              </h2>
              <p className="flex justify-center text-gray-800 font-semibold text-base">
                {getCardSubtitle()}
              </p>
            </div>
            <div className="flex flex-col text-gray-800 gap-2">
              <CustomInput
                name="Follow up date"
                className="col-span-6 !py-3 min-h-[70px] bg-white"
                label="Appointment Date & Time"
                labelClassName="whitespace-nowrap"
                type="date"
                value={MRDate}
                onChange={(e) => {
                  setMRDate(e);
                }}
                disabled
              />
              <Button
                className="col-span-12 !py-3 min-h-[70px] flex items-center"
                text={getButtonText()}
                type="primary"
                onClick={handleButtonClick}
                disabled={true}
              />
            </div>
          </div>
        )}
        {MRDate !== null && (
          <div className="flex flex-col h-[320px] pt-5 pb-2 gap-5 px-12 justify-center items-center">
            <div className="flex justify-center">
              <ReactSVG
                src={`/icons/follow-up.svg`}
                className={``}
              />
            </div>
            <h2 className="text-xl font-bold flex justify-center text-teal-300">
              {getBookedTitle()}
            </h2>
            <div className="flex flex-col text-gray-800 gap-[4px] justify-center">
              <p className="text-base font-medium">
                {getBookedText()}{" "}
                {formatToYYYY_MMM_DD(MRDate)}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ThirdCardFollowUp;